import React from 'react'
import { PipelineType } from 'src/models/IPipeline'
import 'src/assets/css/components/pipelineType.css'

/** A pipeline type's own icon, on its type's colour: an ingestion flows one way, a workflow branches (MEL-702). */
const PipelineTypeIcon = ({ type }: { type: PipelineType }): JSX.Element =>
    <span className={`split-button-option-icon pipeline-type-icon ${type.toLowerCase()}`} aria-hidden>
        <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
            {type === PipelineType.Ingestion
                ? <path d='M4 7h11M4 12h11M4 17h11M15 4l5 8-5 8' />
                : <>
                    <circle cx='5' cy='6' r='2' />
                    <circle cx='5' cy='18' r='2' />
                    <circle cx='19' cy='12' r='2' />
                    <path d='M7 6h4l6 6M7 18h4l6-6' />
                </>}
        </svg>
    </span>

export default PipelineTypeIcon
